module.exports = __webpack_public_path__ + "img/icon-global.983e23cb.png";